import Hero from "../components/Hero";
import GoldBenefits from "../components/GoldBenefits";
import Features from "../components/Features";
import Recommendations from "../components/Recommendations";

export default function Home() {
    return (
        <>
            <Hero />
            <div className="mx-5 md:mx-36 flex flex-col space-y-6 md:space-y-20 items-start mt-20">
                <div className="gold-line-gradient h-0.5 w-full"></div>
                <p className="text-2xl lg:text-3xl font-black">
                    MediBuddy Gold Benefits
                </p>
            </div>
            <div className="red-wave">
                <div className="mx-5 md:mx-36 flex flex-wrap-reverse justify-between">
                    <GoldBenefits/>
                </div>
            </div>
            <div className="mx-5 md:mx-36 flex flex-col space-y-6 md:space-y-20 items-start mt-20">
                <div className="gold-line-gradient h-0.5 w-full"></div>
                <p className="text-2xl lg:text-3xl font-black">
                    Consult with Doctors from top hospitals 24x7
                </p>
            </div>

            <div className="blue-wave">
                <div className="mx-5 md:mx-36">
                    <Features />
                </div>
            </div>
            <div className="mx-5 md:mx-36 flex flex-col space-y-6 md:space-y-20 items-start mt-20">
                <div className="gold-line-gradient h-0.5 w-full"></div>
                <p className="text-2xl lg:text-3xl font-black">
                    Watch Arjun Kapoor talk about MediBuddy Gold
                </p>
            </div>

            <div className="red-wave">
                <div className="mx-5 md:mx-36">
                    <Recommendations />
                </div>
            </div>
        </>
    );
}
